import { type PropsWithChildren, useMemo } from 'react';

import { CheckoutContext } from './CheckoutProvider.context';
import type { CheckoutProviderContext } from './checkout-provider.types';

interface CheckoutProviderProps
  extends Omit<CheckoutProviderContext, 'checkoutId'>,
    PropsWithChildren {
  checkoutId?: string;
}

const CheckoutProvider = ({
  children,
  checkoutId,
  onCheckoutSuccess,
  withCheckoutSuccessNotification = true,
  checkoutOrderSectionConfig,
}: CheckoutProviderProps) => {
  const context = useMemo(
    () => ({
      checkoutId,
      onCheckoutSuccess,
      checkoutOrderSectionConfig,
      withCheckoutSuccessNotification,
    }),
    [checkoutId, onCheckoutSuccess, checkoutOrderSectionConfig, withCheckoutSuccessNotification]
  );
  if (!checkoutId) {
    return null;
  }
  return (
    // Asserts the context to the correct type since we've already checked that the checkoutId is not undefined
    <CheckoutContext.Provider value={context as CheckoutProviderContext}>
      {children}
    </CheckoutContext.Provider>
  );
};

export { CheckoutProvider };

export type { CheckoutProviderProps };
